import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
    selector: 'app-citylist',
    templateUrl: './citylist.page.html',
    styleUrls: ['./citylist.page.scss'],
})
export class CitylistPage implements OnInit {
    @Input() citylist: any = {};
    @Input() orginallist: any = {};
    constructor(
        public router: Router,
        public platform: Platform,
        public modalCtrl: ModalController,
    ) {
    }
    ngOnInit() {
        console.log(this.citylist, this.orginallist);
    }
    getCityList = (ev: any) => {
        var val = ev.target.value;
        if (val && val.trim() != '') {
            this.citylist = this.citylist
                .filter((city) => {
                    if (this.platform.isRTL)
                        return (city.title.indexOf(val) > -1 || city.description.toLowerCase().indexOf(val.toLowerCase()) > -1);
                    else
                    return (city.title.indexOf(val) > -1 || city.description.toLowerCase().indexOf(val.toLowerCase()) > -1);
                }
                );
        }
    }
    clearCityLists = () => {
        this.citylist = this.orginallist;
    }
    selectedCityItem = (cityData: any) => {
        this.modalCtrl.dismiss(cityData, 'close');
    }
    closeModal = () => {
        this.modalCtrl.dismiss(null, 'cancel');
    }
}
